import React, { useMemo } from 'react';
import { useMatches } from 'react-router-dom';
import { User as UserType } from '../../types';
import OrganizationSelector from './OrganizationSelector';
import SearchBar from './SearchBar';
import { useOrganization } from '../../contexts/OrganizationContext';

interface HeaderProps {
  user: UserType | null;
}

const Header: React.FC<HeaderProps> = ({ user }) => {
  const { currentOrganization, isLoading } = useOrganization();
  const matches = useMatches();
  const currentTitle = useMemo(() => {
    const matchWithTitle = matches.reverse().find((match) => {
      const handle = match.handle as { title?: string } | undefined;
      return handle?.title;
    });
    const handle = matchWithTitle?.handle as { title?: string } | undefined;
    return handle?.title || 'KYC Pro';
  }, [matches]);


  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{currentTitle}</h1>
        </div>

        <div className="flex items-center space-x-4">
          {/* Search Bar */}
          {(currentOrganization || isLoading) && <SearchBar />}

          {/* Organization Selector */}
          <OrganizationSelector userEmail={user?.email} />
        </div>
      </div>
    </header>
  );
};

export default Header;